import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import Api from '../components/Api/Api';
import { getToken } from '../util/tokenManager';

export const postUser = createAsyncThunk(
  'users/postUser',
  async (initialData) => {
    console.log(initialData);
    try {
      const response = await Api.post('/users', initialData);
      return { success: true, data: response };
    } catch (err) {
      throw err;
    }
  }
);

export const fetchUser = createAsyncThunk('users/fetchUser', async () => {
  const response = await Api.get('/users');
  return [...response];
  // return response.data; // Extracting only serializable data
});

export const logInUser = createAsyncThunk(
  'users/logInUser',
  async (loginData, { rejectWithValue }) => {
    try {
      const response = await Api.post('/users/login', loginData);
      return { success: true, data: response };
    } catch (err) {
      return rejectWithValue(err.response ? err.response.data : err.message);
    }
  }
);

export const updateUser = createAsyncThunk(
  'user/updateUser',
  async (updatedUserData, { getState, rejectWithValue }) => {
    const currentUser = getState().user.currentUser; // Access user object
    const token = getToken(); // Get token from tokenManager
    if (!token) {
      return rejectWithValue('No token found - user not authenticated');
    }

    try {
      // Authorization header is automatically added by API interceptor
      const response = await Api.put(
        `/users/${currentUser.id}`,
        updatedUserData
      );

      return { success: true, data: response.data };
    } catch (error) {
      console.error(
        'Update User Error:',
        error.response?.data || error.message
      );
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

const initialState = {
  users: [],
  loadingStatus: '',
  currentUser: null,
  error: null,
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    logOut(state) {
      state.currentUser = null;
      // Token cleanup is handled by tokenManager.clearToken()
    },
    setCurrentUser(state, action) {
      state.currentUser = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(postUser.pending, (state) => {
        state.loadingStatus = 'pending';
      })
      .addCase(postUser.fulfilled, (state, action) => {
        state.users.push(action.payload);
        state.loadingStatus = 'fulfilled';
      })
      .addCase(postUser.rejected, (state) => {
        state.loadingStatus = 'failed';
        state.error = action.error.message;
      })
      .addCase(fetchUser.pending, (state) => {
        state.loadingStatus = 'pending';
      })
      .addCase(fetchUser.fulfilled, (state, action) => {
        state.users.push(action.payload);
        state.loadingStatus = 'fulfilled';
      })
      .addCase(fetchUser.rejected, (state) => {
        state.loadingStatus = 'failed';
        state.error = action.error.message;
      })
      .addCase(logInUser.pending, (state) => {
        state.loadingStatus = 'pending';
      })
      .addCase(logInUser.fulfilled, (state, action) => {
        state.currentUser = action.payload.data.token;
        state.loadingStatus = 'fulfilled';
      })
      .addCase(logInUser.rejected, (state) => {
        state.loadingStatus = 'failed';
        // state.error = action.error.message;
      })
      .addCase(updateUser.pending, (state) => {
        state.loadingStatus = 'pending';
      })
      .addCase(updateUser.fulfilled, (state, action) => {
        state.currentUser = action.payload.data;
        state.loadingStatus = 'fulfilled';
      })
      .addCase(updateUser.rejected, (state) => {
        state.loadingStatus = 'failed';
        // state.error = action.error.message;
      });
  },
});

export const { logOut, setCurrentUser } = userSlice.actions;
export default userSlice;
